import React from 'react';
import DataTable from "../../../DataTable";
import { inject, observer } from 'mobx-react';
import { Link } from "react-router";
import Spinner from "../../../Spinner";

@inject('ticketStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'stationStore')
@observer
export default class StationTicketList extends React.Component {

  slug = `station/${this.props.params.id}/maintenance/ticket`;
  columns = [
    { key: 'ticket_id', label: 'Ticket Number' },
    { key: 'summary', label: 'Summary' },
    { key: 'status', label: 'Status' },
    { key: 'reason', label: 'Reason' },
    { key: 'action', label: 'Action' },
    { key: 'assigned_to', label: 'Assigned To' },
    { key: 'duration', label: 'Duration' }
  ];

  handleDelete = (idOrIds) => {
    console.log('handleDelete', idOrIds);
    this.props.ticketStore.removeItems(idOrIds);
  };

  render() {
    const { stationStore, ticketStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, ticketView, params: { id }, view_archived } = this.props;

    if ((ticketStore.isLoading || stationStore.isLoading || userStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading)) {
      return <Spinner />;
    }

    if (ticketView) return React.cloneElement(ticketView, { view_archived });

    let items = ticketStore.items.filter(item => +item.station_id === +id).filter(item => view_archived ? true : !item.archived).map(item => {
      let user = userStore.findById(item.assigned_to);
      let status = ticketStatusStore.findById(item.status_id),
        reason = ticketReasonStore.findById(item.reason_id),
        action = ticketActionStore.findById(item.action_id);
      return {
        id: item.id,
        ticket_id: <div>{item.id} {item.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}</div>,
        summary: <Link to={`/station/${id}/maintenance/ticket/${item.id}/view`}>{item.summary || 'View'}</Link>,
        status: status && status.caption,
        reason: reason && reason.caption,
        action: action && action.caption,
        assigned_to: user && user.name,
        duration: item.last_log && item.last_log.log_date ? ticketStore.getDuration(item.last_log.log_date) : ticketStore.getDuration(item.generated_date)
      }
    });

    return (
      <div>
        <DataTable
          data={items}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
        // allowDelete
        />
        {this.props.children ? React.cloneElement(this.props.children, { slug: this.slug, station_id: id, view_archived }) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Station/Maintenance/Ticket/StationTicketList.js